import PoweredBy from "../../../components/PoweredBy";
import { linksConstants } from "../../../constants";
import RegistrationForm from "./RegistrationForm";
import { useParams } from "react-router-dom";
import {
  callConfigurationAPI,
  callJoinStream,
} from "../../../services/main.service";
import LiveMain from "../../live-main";
import { useEffect, useState } from "react";
import useAppAccessor from "../../../hooks/useappAccessor";
import { removeItem } from "../../../lib/storage";
import Loader from "../../../components/loader";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { setRoleCoPresenter } from "../../agora-live/components/streamControls/controls.actions";
import { validateReferrerToken } from "../../../services/validateToken.service";
import { setClient, setLanguage, setReferrenUserInfo } from "../Login/login.actions";
import WaittingRoom from "../WaitingRoom";
import {
  getBrandColor,
  REGISTRATION_PARTNER_CO_COLOR,
} from "../../../utils/brand.util";

export default function Registration() {
  const { id } = useParams();
  const [attendeeJoined, setAttendeeJoined] = useState(false);
  const { getControls } = useAppAccessor();
  const { isHostPassLogin } = getControls();
  const [hostData, setHostData] = useState<any>(null);
  const dispatch = useAppDispatch();
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isWaitting, setIsWaiting] = useState(false);
  const [userReferrer, setUserReferrer] = useState<any>(null);
  const { getUserData } = useAppAccessor();

  const { language, client } = getUserData();
  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

  useEffect(() => {
    if (localStorage.getItem("jwt_token")) {
      setIsShowLoader(true);
      //TODO: To be reviewed
      // removeItem("jwt_token");

      setTimeout(() => {
        setIsShowLoader(false);
      }, 2000);
    }

    const search = window.location.search;
    const params = new URLSearchParams(search);
    const attendee_token = params.get("attendee_token");
    const referrer_token = params.get("referrer_token");

    if (attendee_token || window.location.href.indexOf("/stream") > -1) {
      dispatch(setRoleCoPresenter(true));
    }
    if (referrer_token) {
      localStorage.setItem("referrer_token", referrer_token);
      dispatch(setRoleCoPresenter(false));
      validateReferrerToken(id).then((res: any) => {
       // console.log(res, "res.issuer_metadata");
        dispatch(setReferrenUserInfo(res?.issuer_metadata));
        setUserReferrer(res?.issuer_metadata);
      });
    }
    callConfigurationAPI(id).then((res: any) => {
      setHostData(res);
      localStorage.setItem("hostData", res.locale);
      dispatch(setClient(res?.company_name));
      
      fetch(`${window.location.origin}/lang/${res.locale ?? "en"}.json`)
      .then((response) => response.json())
      .then((data) => {
        dispatch(setLanguage(data));
      })
      .catch((error) => {
        dispatch(setLanguage({
          "mic_active": "Your microphone is active.",
          "mic_inactive": "Your microphone is muted.",
          "camera_active": "Your camera is active.",
          "camera_inactive": "Your camera is turned off.",
          "mic_camera_inactive": "Your camera is turned off. Your microphone is muted.",
          "go_live": "Go Live",
          "Interactions": "Interactions",
          "Chat": "Chat",
          "Edit": "Edit",
          "feature": "Feature",
          "featured": "Featured",
          "attendees": "Attendees",
          "activities": "Activities",
          "what_on_your_mind": "What's on your mind?",
          "start_live_to_record": "You must start a LIVE stream to record",
          "logout": "Logout",
          "cancel": "Cancel",
          "data_processing_agreement": "Data Processing Agreement",
          "privacy_policy": "Privacy Policy",
          "starting_stream": "Starting Stream",
          "record_on": "Recording is ON",
          "record_off": "Recording is OFF",
          "add_interactions": "Add Interactions",
          "sell": "Sell",
          "media": "Media",
          "link": "Link",
          "select_products": "Select the products you'd like to add",
          "search": "Search",
          "filter_by": "Filter by",
          "publish": "Publish",
          "tap_media": "Tap on the media you'd like to add",
          "add_link": "Add Link",
          "add_links": "You can add links to your live, from websites to social media and instant messengers",
          "link_type": "Link Type",
          "social_media": "Social Media",
          "messengers": "Messengers",
          "custom": "Custom",
          "enter_xxxx_link": "Enter XXXXX link",
          "title": "Title",
          "enter_title": "enter title",
          "display_title": "Display Title",
          "preview": "Preview",
          "add": "Add",
          "upload_image": "Upload custom image",
          "upload_image_successfully": "Upload Successfully!",
          "join_the_livestream": "Join the LIVEstream",
          "join": "Join",
          "sign_up_for_free": "Sign Up for Free",
          "sign_in": "Sign In",
          "verb_crm_user": "Verb CRM user",
          "need_help": "Need help",
          "sign_in_agreement_short": "By signing in, you agree to the data processing agreement and privacy policy",
          "joining_stream": "Joining Stream",
          "my_media": "My media",
          "Save": "Save",
          "Leave": "Leave",
          "leave_video": "Leave Video",
          "ending_stream": "Ending stream",
          "host_mic_video": "Host has turned off his video and muted his Mic",
          "host_mic": "Host has muted his Mic",
          "host_video": "Host has turned off his video",
          "YES": "YES",
          "NO": "NO",
          "EXIT": "Exit the livestream?",
          "you_logged_out": "You logged out",
          "more_options": "More options",
          "last_signed": "Last Signed in through",
          "by_signing": "By signing in, you agree to the",
          "auth_succeess": "Authentication succesful",
          "no_permission_record": "You don't have permission to record",
          "new_chats": "New Chats",
          "has_joined": "has joined",
          "clicked_on": "clicked on",
          "representing_by": "Representing by",
          "referred_by": "Referred by ",
          "please_register": "please register",
          "to_attend": "To attend the LIVE stream",
          "enter_first_name": "Enter First Name",
          "enter_last_name": "Enter Last Name",
          "enter_email": "Enter Email",
          "hosted_by": "The LIVE stream hosted by",
          "starting_soon": " will be starting soon.",
          "and": "and",
          "or": "or",
          "terms_of_use": "terms of use",
          "has_left": "has left",
          "host_ended_live": "The host ended the live.",
          "data_privacy_agreement": "data privacy agreement",
          "to_livestream": "To Livestream",
          "need_access": "We need access to your camera and microphone.",
          "open_settings": "Open Settings",
          "sign_up": "Sign Up",
          "internet_unstable": "Your Internet is Unstable",
          "got_it": "Got It",
          "settings": "Settings",
          "plan": "Plan",
          "max_attendees": "Max Attendees",
          "max_number": "Max Number of minutes",
          "stream_settings": "Stream Settings",
          "hide_attendee_list": "Hide attendee list and number from stream attendees",
          "ability_to_record": "Ability To Record Stream",
          "ability_to_copresenter": "Ability To Have A Co-presenter",
          "sign_out": "Sign Out",
          "questions_or_need_help": "Questions or Need help",
          "add_your_first_interaction": "Add your first interaction",
          "host_internet_unstable": "Host's Internet is Unstable",
          "invalid_url": "The URL you entered is not valid.",
          "link_invalid": "The link is invalid or expired.",
          "contact_for_new_url": "Please contact the person who sent you this link to get a new one.",
          "welcome_back": "Welcome back! Let's go live again.",
          "to_go_live": "To go live, create a free account.",
          "record_is_starting": "Recording is starting...",
          "record_has_started": "Recording has started.",
          "record_is_ending": "Recording is ending...",
          "record_has_ended": "Recording has ended.",
          "enter_ID": "Enter the meeting I.D, number",
          "clicking_join": "Clicking join indicates that you have read and agree to the ",
          "plan_features": "Plan features",
          "attendees_per_live_stream": "Attendees per Live Stream",
          "minutes_per_live_stream": "Minutes per Live Stream",
          "co_presenter_per_live_stream": "Co-presenter per Live Stream",
          "EULA_title": "Updated Terms of Use, Privacy Policy, and Data Processing Agreement",
          "EULA_body": "Before you can proceed, you must read and agree to the Terms of Use, Privacy Policy, and Data Processing Agreement.",
          "agree": "Agree",
          "view": "View",
          "report_this_post": "Report this post",
          "why_report": "Why should this content be flagged",
          "send": "Send",
          "end_session": "Your Livestream is in session.",
          "confirm_sign_out": "Are you sure you want to sign out?",
          "first_name": "First Name",
          "last_name": "Last Name",
          "email": "Email",
          "agree_join": "By joining you agree to our ",
          "enter_password": "Enter Password",
          "done": "Done",
          "select_site": "Select Site",
          "guide_select_site": "You can only add products from one site to your live. To add products from another site, your live will need to be restarted.",
          "brand": "brand",
          "category": "Category",
          "sub_category": "Sub Category",
          "introduce_golive": "Go live anywhere, anytime",
          "introduce_boost": "Boost engagement with clickable interactions",
          "introduce_record": "Record the livestreams to create sales videos",
          "introduce_invite": "Invite attendees with simple shareable links",
          "join_as_copresenter": "You are joining this LIVEstream as a co-presenter.",
          "waiting_room_join_as_copresenter": "You will join as a co-presenter as soon as the host goes live.",
          "max_presenters": "Max Presenters",
          "next": "Next",
          "skip": "Skip",
          "user_info": "User Info",
          "display_info_updated": "Display information has been updated",
          "edit_info": "Edit Info",
          "delete": "delete",
          "copresenter": "Co-presenter",
          "copresenter_join": "has joined the meeting as a co-presenter and has audio and video capabillity",
          "confirm_leave": "Are you sure you want to leave this stream?",
          "Attendee": "Attendee",
          "Invite": "Invite",
          "you_joined_copresenter": "You have joined the meeting as a co-presenter and have audio and video capability.",
          "confirm_leave_host": "Are you sure you want to end this stream?",
          "start_your_live_stream": "Start your Live stream",
          "share_your_live_stream": "Share your Live stream",
          "list_view_live_interaction": "List view Live interactions",
          "record_stream": "Record Stream",
          "chat_with_attendees": "Chat with Attendees",
          "poor_internet": "Poor internet connection. ",
          "have_av_issues": "The livestream may have audio or video issues.",
          "no_msg": "There are no chat messages yet",
          "go_live_to_start_chatting": "Go live to start chatting",
          "feature_label": "Featured",
          "up_to": "Up",
          "to_limit": "to",
          "minutes_value": "minutes",
          "select_microphone": "Select Microphone",
          "microphone_prompt": "Please select a microphone",
          "input_level": "Input Level",
          "use_portrait": "Use Portrait",
          "select_camera": "Select Camera",
          "camera_prompt": "Please select a camera",
          "preview_label": "Preview:",
          "select_products_prompt": "Select the products that you want to add.",
          "select_brand": "Select Brand",
          "select_categories": "Select Categories",
          "select_sub_categories": "Select Sub Categories",
          "search_label": "Search",
          "creating_stream": "Creating stream please wait...",
          "whats_on_mind": "What's on your mind?",
          "select_media_assets": "Select the media assets you'd like to import from verbCRM.",
          "add_button": "Add",
          "all_button": "All",
          "share_button": "Share",
          "copy_button": "Copy",
          "link_copied": "Link copied to clipboard.",
          "microphone_muted": "Your microphone is muted",
          "microphone_active": "Your microphone is active",
          "camera_off": "Your camera is turned OFF",
          "camera_on": "Your camera is turned ON",
          "joining_stream_wait": "Joining stream please wait",
          "no_interactions": "Interactions have not been added yet",
          "shop_label": "shop",
          "cart_label": "Cart",
          "no_items": "No items have been added",
          "ending_stream_wait": "Ending stream please wait",
          "left_livestream": "You left the live stream",
          "rejoin_button": "Rejoin",
          "please_wait": "Please wait…",
          "register_view": "Register to view LIVEstream",
          "first_name_field": "First Name",
          "last_name_field": "Last Name",
          "email_field": "Email",
          "join_button": "Join",
          "join_agreement": "Clicking join indicates you have read and agree to the",
          "livestream_hosted": "The LIVEstream hosted by",
          "starting_soon_text": "will be starting soon.",
          "representing_label": "Representing",
          "referred_by_label": "Referred by",
          "host_mic_muted": "Host microphone is muted",
          "already_in_interactions": "is already present in your interactions list",
          "item_label": "Item",
          "exit_livestream": "Exit the live stream?",
          "yes_button": "YES",
          "no_button": "NO",
          "add_to_cart": "Add to cart",
          "update_cart": "Update cart",
          "cashback_label": "Cashback",
          "see_details": "See Details",
          "added_to_cart": "Added to Cart",
          "no_results": "No Results Found",
          "cannt_find": "We can't seem to find any products that match your search.",
          "screen_share": "Screen Share is OFF"
      }));
        console.error(error);
      });
      


    });
  }, []);

  const truncatePictureName = (name: string) => {
    if (name) {
      const initials = name?.split(" ");
      const charAtBegin = initials[0].charAt(0).toUpperCase();
      const charAtLast = initials[initials.length - 1].charAt(0).toUpperCase();

      return charAtBegin + charAtLast;
    } else {
      return;
    }
  };

  function handleLinkClick(event: any, url: any) {
    event.preventDefault();
    window.open(url, "_blank");
  }

  const brandColor =
    client === "partner.co" ? REGISTRATION_PARTNER_CO_COLOR : getBrandColor(client);

  const getInitials = (name: string) => {
    if (!name) return "U";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const truncateFullName = (name: string) => {
    if (name) {
      const data = name?.split(" ");
      return data[0] + " " + data[data.length - 1];
    } else {
      return;
    }
  };

  if (attendeeJoined || isHostPassLogin) {
    return <LiveMain />;
  } else if (isWaitting) {
    return (
      <WaittingRoom
        hostName={hostData?.host_fullname}
        companyName={hostData?.company_name}
        referrerName={
          userReferrer
            ? userReferrer?.webhook_referrer_name
            : truncateFullName(hostData?.host_fullname || "")
        }
        hostPicture={hostData?.host_picture}
      />
    );
  } else {
    return (
      <>
        <div 
          className="flex flex-1 items-center justify-center min-h-screen"
          style={{
            background: "linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #1a1a1a 100%)",
          }}
        >
          {!isMobile ? (
            <div className="flex flex-col items-center w-full px-4 py-8 max-w-6xl">
              <div
                className="flex flex-row w-full rounded-3xl overflow-hidden relative"
                style={{
                  background: "linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <div 
                  className="absolute top-0 left-0 right-0 h-1 rounded-t-3xl"
                  style={{ backgroundColor: brandColor }}
                />
                
                <div className="flex flex-col flex-1 px-8 py-10">
                  <h2 className="text-white text-2xl font-semibold mb-6 text-center tracking-tight">
                    {language["join_the_livestream"]}
                  </h2>
                  
                  <RegistrationForm
                    hostData={hostData}
                    roomId={id}
                    waitting={isWaitting}
                    setWaittingCallback={(val: boolean) => setIsWaiting(val)}
                    attendeeJoinedCallback={() => setAttendeeJoined(true)}
                    autoFill={false}
                  />
                  
                  <div 
                    className="w-full pt-6 mt-6 border-t"
                    style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}
                  >
                    <p className="text-gray-400 text-xs text-center leading-relaxed">
                      {language["join_agreement"]}{" "}
                      <a
                        href={linksConstants.data_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.data_url)}
                      >
                        {language["data_privacy_agreement"].charAt(0).toUpperCase() +
                          language["data_privacy_agreement"].slice(1)}
                      </a>
                      ,{" "}
                      <a
                        href={linksConstants.privacy_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.privacy_url)}
                      >
                        {language["privacy_policy"].charAt(0).toUpperCase() +
                          language["privacy_policy"].slice(1)}
                      </a>{" "}
                      and{" "}
                      <a
                        href={linksConstants.terms_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.terms_url)}
                      >
                        {language["terms_of_use"].charAt(0).toUpperCase() +
                          language["terms_of_use"].slice(1)}
                      </a>
                      .
                    </p>
                  </div>
                </div>

                <div 
                  className="w-px mx-4"
                  style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                />

                <div className="flex flex-col items-center justify-center flex-1 px-8 py-10">
                  <div
                    className="flex items-center justify-center rounded-full mb-6 transition-transform duration-300 hover:scale-105"
                    style={{
                      width: "120px",
                      height: "120px",
                      background: hostData?.host_picture 
                        ? "transparent"
                        : `linear-gradient(135deg, ${brandColor} 0%, ${brandColor}dd 100%)`,
                      boxShadow: `0 4px 16px ${brandColor}40, 0 2px 8px ${brandColor}20`,
                    }}
                  >
                    {hostData?.host_picture ? (
                      <img
                        className="h-full w-full object-cover rounded-full"
                        src={hostData?.host_picture}
                        alt="Host"
                      />
                    ) : (
                      <span 
                        className="text-white font-semibold text-4xl"
                        style={{ textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)" }}
                      >
                        {getInitials(hostData?.host_fullname || "")}
                      </span>
                    )}
                  </div>

                  <div className="flex flex-col items-center w-full space-y-4 mb-6">
                    <p className="text-white text-base font-medium text-center leading-relaxed">
                      {language['livestream_hosted']}{" "}
                      <span
                        className="font-semibold"
                        style={{ color: brandColor }}
                      >
                        {hostData?.host_fullname}
                      </span>
                      {" "}{language['starting_soon_text']}
                    </p>

                    <div className="flex flex-col items-center w-full space-y-3 pt-2">
                      {hostData?.company_name && (
                        <div className="flex items-center justify-center">
                          <span className="text-gray-400 text-sm mr-2">
                            {language['representing_label']}
                          </span>
                          <span 
                            className="text-white text-sm font-medium"
                            style={{ color: brandColor }}
                          >
                            {hostData?.company_name}
                          </span>
                        </div>
                      )}

                      <div className="flex items-center justify-center">
                        <span className="text-gray-400 text-sm mr-2">
                          {language['referred_by_label']}
                        </span>
                        <span 
                          className="text-white text-sm font-medium"
                          style={{ color: brandColor }}
                        >
                          {userReferrer
                            ? userReferrer?.webhook_referrer_name
                            : truncateFullName(hostData?.host_fullname || "")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8">
                <PoweredBy />
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center w-full px-4 py-4 min-h-screen">
              <div
                className="flex flex-col w-full max-w-md rounded-3xl overflow-hidden relative"
                style={{
                  background: "linear-gradient(145deg, #2d2d2d 0%, #1a1a1a 100%)",
                  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5), 0 4px 16px rgba(0, 0, 0, 0.3)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <div 
                  className="absolute top-0 left-0 right-0 h-1 rounded-t-3xl"
                  style={{ backgroundColor: brandColor }}
                />
                
                <div className="flex flex-col items-center px-4 py-4 w-full">
                  <div
                    className="flex items-center justify-center rounded-full mb-3 transition-transform duration-300"
                    style={{
                      width: "64px",
                      height: "64px",
                      background: hostData?.host_picture 
                        ? "transparent"
                        : `linear-gradient(135deg, ${brandColor} 0%, ${brandColor}dd 100%)`,
                      boxShadow: `0 4px 16px ${brandColor}40, 0 2px 8px ${brandColor}20`,
                    }}
                  >
                    {hostData?.host_picture ? (
                      <img
                        className="h-full w-full object-cover rounded-full"
                        src={hostData?.host_picture}
                        alt="Host"
                      />
                    ) : (
                      <span 
                        className="text-white font-semibold text-xl"
                        style={{ textShadow: "0 2px 4px rgba(0, 0, 0, 0.3)" }}
                      >
                        {getInitials(hostData?.host_fullname || "")}
                      </span>
                    )}
                  </div>

                  <div className="flex flex-col items-center w-full mb-4">
                    <p className="text-white text-sm font-medium text-center mb-1.5 leading-tight">
                      {language['livestream_hosted']}{" "}
                      <span
                        className="font-semibold"
                        style={{ color: brandColor }}
                      >
                        {hostData?.host_fullname}
                      </span>
                      {" "}{language['starting_soon_text']}
                    </p>
                    
                    <div className="flex flex-col items-center w-full space-y-1.5 pt-1">
                      {hostData?.company_name && (
                        <div className="flex items-center justify-center">
                          <span className="text-gray-400 text-xs mr-1.5">
                            {language['representing_label']}
                          </span>
                          <span 
                            className="text-white text-xs font-medium"
                            style={{ color: brandColor }}
                          >
                            {hostData?.company_name}
                          </span>
                        </div>
                      )}

                      <div className="flex items-center justify-center">
                        <span className="text-gray-400 text-xs mr-1.5">
                          {language['referred_by_label']}
                        </span>
                        <span 
                          className="text-white text-xs font-medium"
                          style={{ color: brandColor }}
                        >
                          {userReferrer
                            ? userReferrer?.webhook_referrer_name
                            : truncateFullName(hostData?.host_fullname || "")}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div 
                    className="w-full mb-4 border-t"
                    style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}
                  />

                  <h2 className="text-white text-lg font-semibold mb-4 text-center tracking-tight">
                    {language["join_the_livestream"]}
                  </h2>
                  
                  <RegistrationForm
                    hostData={hostData}
                    roomId={id}
                    waitting={isWaitting}
                    setWaittingCallback={(val: boolean) => setIsWaiting(val)}
                    attendeeJoinedCallback={() => setAttendeeJoined(true)}
                    autoFill={false}
                  />
                  
                  <div 
                    className="w-full pt-4 mt-4 border-t"
                    style={{ borderColor: "rgba(255, 255, 255, 0.1)" }}
                  >
                    <p className="text-gray-400 text-xs text-center leading-tight px-2">
                      {language["join_agreement"]}{" "}
                      <a
                        href={linksConstants.data_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.data_url)}
                      >
                        {language["data_privacy_agreement"]}
                      </a>
                      ,{" "}
                      <a
                        href={linksConstants.privacy_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.privacy_url)}
                      >
                        {language["privacy_policy"]}
                      </a>{" "}
                      and{" "}
                      <a
                        href={linksConstants.terms_url}
                        className="transition-colors duration-200 hover:opacity-80"
                        style={{ color: brandColor }}
                        onClick={(e) => handleLinkClick(e, linksConstants.terms_url)}
                      >
                        {language["terms_of_use"]}
                      </a>
                      .
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 mb-2">
                <PoweredBy />
              </div>
            </div>
          )}
        </div>

        <Loader
          message={"Logging out from previous user. Please wait..."}
          isShowLoader={isShowLoader}
        />
      </>
    );
  }
}
